import { NULL } from "constants/primitives";
import { YEAR_IN_SECONDS } from "constants/time";
import { _DOCUMENT_ } from "constants/dom";
import getTimestamp from "./getTimestamp";
import objectKeys from "./objectKeys";
import { IBulkConfig } from "types/config-files/mainConfig";

/**
 * Converts timestamp in seconds into a cookie expiration string expected by browser
 *
 * @param {number} expiration cookie expiration timestamp in seconds
 * @returns {string} cookie expiration string
 */
const calculateCookieExpiration = (expiration: number): string => {
  const date = new Date();
  date.setTime(expiration * 1000);
  return date.toUTCString();
};

const saveLocalCookie = (
  name: string,
  value: string,
  expiration: number | null = null,
  bulkConfig: IBulkConfig | null,
) => {
  const cookieExpiration = expiration !== null
    ? expiration
    : getTimestamp() + YEAR_IN_SECONDS;

  const cookie = {
    [name]: encodeURIComponent(value),
    expires: calculateCookieExpiration(cookieExpiration),
    path: "/",
    SameSite: "Lax",
    secure: window.location.protocol === "https:",
  };

  if (bulkConfig && bulkConfig.id && bulkConfig.baseDomain) {
    cookie.domain = bulkConfig.baseDomain;
  }

  const cookieString = objectKeys(cookie)
    .map((key) => {
      const value = cookie[key];
      if (typeof value === "boolean") {
        return value ? key : NULL;
      }

      return `${key}=${value}`;
    }, [])
    .filter(Boolean)
    .join("; ");

  _DOCUMENT_.cookie = cookieString;

  return cookieString;
};

export default saveLocalCookie;
